import { ErrorCode } from '@planning/utils/ErrorCode/error-code-enum'
import {
  getDomainModelExceptionPayload,
  isDomainModelException,
} from '@planning/utils/ErrorCode/error-code-utils'
import { useTranslate } from '@tolgee/react'
import { AxiosError } from 'axios'

export const useOrderListUploadMessagesHandler = () => {
  const { t } = useTranslate()

  const getExceptionMessage = (error: any) => {
    if (isDomainModelException(error, ErrorCode.ContainersDuplicatedInUploadFile)) {
      const payload = getDomainModelExceptionPayload(
        error,
        ErrorCode.ContainersDuplicatedInUploadFile,
      )

      return t(
        'theContainersAreDuplicatedInUploadFile',
        'The containers {containerNumbers} are duplicated in the upload file',
        {
          containerNumbers: payload?.containerNumbers,
        },
      )
    }

    if (isDomainModelException(error, ErrorCode.ContainersAlreadyAssignedToCarrierVisit)) {
      const payload = getDomainModelExceptionPayload(
        error,
        ErrorCode.ContainersAlreadyAssignedToCarrierVisit,
      )

      return t(
        'theContainersAreAlreadyAssignedToCarrierVisit',
        'The containers {containerNumbers} are already assigned to the carrier visit',
        {
          containerNumbers: payload?.containerNumbers,
        },
      )
    }

    if (error instanceof AxiosError && error.response?.data?.detail) {
      return error.response?.data?.detail
    } else if (error instanceof AxiosError && error.response?.data?.errors) {
      const obj = Object.values(error.response?.data?.errors) as string[]
      if (obj.length) return obj[0]
    } else if (error instanceof AxiosError && error.response?.data?.message) {
      return error.response?.data?.message
    } else {
      return t('failToUploadFile', 'Fail to upload file')
    }
  }

  return { getExceptionMessage }
}
